export default theme => ({
	wrapper: {
		display: "flex",
		flexDirection: "row",
	},
	header: {
		width: "100vw",
	},
	main: {
		width: "75vw",
		height: "100%",
	},
	sidebar: {
		width: "25vw",
		height: "100%",
	},
	scrollDown: {
		display: "none",
		position: "fixed",
		zIndex: 999,
		bottom: "15px",
		right: "17px",
		"& svg": {
			fill: "#fff",
			width: "2em",
			height: "2em",
		},
	},
	[theme.breakpoints.down("sm")]: {
		wrapper: {
			display: "flex",
			flexDirection: "column-reverse",
		},
		header: {
			width: "100vw",
		},
		main: {
			width: "100vw",
			height: "auto",
		},
		sidebar: {
			width: "100vw",
			height: "auto",
		},
		scrollDown: {
			display: "block",
		},
	},
});
